export {default as PrefabBase}						from "./prefabs/PrefabBase";
export {default as PrimitiveCapsulePrefab}			from "./prefabs/PrimitiveCapsulePrefab";
export {default as PrimitiveConePrefab}				from "./prefabs/PrimitiveConePrefab";
export {default as PrimitiveCubePrefab}				from "./prefabs/PrimitiveCubePrefab";
export {default as PrimitiveCylinderPrefab}			from "./prefabs/PrimitiveCylinderPrefab";
export {default as PrimitivePlanePrefab}			from "./prefabs/PrimitivePlanePrefab";
export {default as PrimitivePolygonPrefab}			from "./prefabs/PrimitivePolygonPrefab";
export {default as PrimitivePrefabBase}				from "./prefabs/PrimitivePrefabBase";
export {default as PrimitiveSpherePrefab}			from "./prefabs/PrimitiveSpherePrefab";
export {default as PrimitiveTorusPrefab}			from "./prefabs/PrimitiveTorusPrefab";